import {
    determineSendSingleInfiniteRequest,
    determineSendSingleRequest,
} from '@cfra-nextgen-frontend/shared/src/components/Screener/api/screener';
import {
    determineGetData,
    determineUseData,
    determineUseMultipleData,
} from '@cfra-nextgen-frontend/shared/src/utils/api';
import { ApiInstanceTypes, ApiNames } from '@cfra-nextgen-frontend/shared/src/utils/enums';
import { API } from 'aws-amplify';

export const getData = determineGetData({
    apiNameToApiDetails: {
        [ApiNames.Wealth]: {
            instance: API,
            instanceType: ApiInstanceTypes.AwsAmplify,
        },
    },
    useDataGetter: (data) => data,
});

export const UseData = determineUseData(getData);
export const UseMultipleData = determineUseMultipleData(getData);
export const sendSingleRequest = determineSendSingleRequest({ UseData });
export const sendSingleInfiniteRequest = determineSendSingleInfiniteRequest({ getData });
